const axios = require('axios');

async function getRetentionChart(days = 30) {
  const resData = await axios.get('/api/v1/admin/retention/chart', { params: { days } });
  return resData.data;
}

module.exports = { getRetentionChart };
